import { NavLink, useLocation } from "react-router-dom";
import { Pizza, ShoppingBag, User } from "lucide-react";
import { useCart } from "@/context/CartContext";

const TABS = [
  { to: "/", label: "Menù", icon: Pizza, id: "tab-menu" },
  { to: "/carrello", label: "Carrello", icon: ShoppingBag, id: "tab-cart" },
  { to: "/profilo", label: "Profilo", icon: User, id: "tab-profile" },
];

export const TAB_PATHS = TABS.map((t) => t.to);

export const TabBar = () => {
  const { count } = useCart();
  const { pathname } = useLocation();
  if (!TAB_PATHS.includes(pathname)) return null;
  return (
    <nav className="sticky bottom-0 z-40 flex" style={{ background: "var(--surface-2)", borderTop: "1px solid var(--border-c)" }} data-testid="tab-bar">
      {TABS.map(({ to, label, icon: Icon, id }) => (
        <NavLink key={to} to={to} end data-testid={id} className="flex-1 flex flex-col items-center justify-center gap-0.5 h-16 relative"
          style={({ isActive }) => ({ color: isActive ? "var(--brand)" : "var(--muted-c)" })}>
          <span className="relative">
            <Icon className="h-6 w-6" />
            {id === "tab-cart" && count > 0 && (
              <span className="absolute -top-1.5 -right-2.5 min-w-[18px] h-[18px] px-1 rounded-full text-[11px] grid place-items-center" style={{ background: "var(--brand)", color: "var(--on-brand)" }} data-testid="tab-cart-badge">{count}</span>
            )}
          </span>
          <span className="text-xs font-medium">{label}</span>
        </NavLink>
      ))}
    </nav>
  );
};
